<template>
  <section
    class="component-be3cb184"
    resmed-component-name="info_30/70_icon-line_image_text_2cta"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': `${acf.layout['background-color']}`,
      'background-size': `${acf.layout['background-size']}`,
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container px-xs-sm-2">
        <div class="row">
          <!-- align-items-center -->
          <div
            class="col-md-5 mb-7 mb-md-0"
            v-bind:class="{
              'order-md-2': acf.layout['image-placement'] === 'right',
            }"
          >
            <figure>
              <img
                class="img-fluid"
                v-bind:class="{ '-box-shadow': acf.layout['box-shadow'] }"
                v-bind:src="acf.image.sizes.large"
                alt=""
              />
            </figure>
          </div>
          <div
            class="col-md-7 pt-md-3"
            v-bind:class="{
              'pl-md-5': acf.layout['image-placement'] === 'left',
              'pr-md-5': acf.layout['image-placement'] === 'right',
            }"
          >
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
            ></eyebrow-icon>
            <div v-bind:class="{ '-has-eyebrow': acf.eyebrow }">
              <div class="title" v-if="acf.name">
                <h5>{{ acf.name }}</h5>
              </div>
              <h2 v-html="acf.headline"></h2>
            </div>
            <div v-if="acf.content" v-html="acf.content"></div>

            <div class="call-to-action mt-4" v-if="acf.cta[0] || acf.cta[1]">
              <a
                v-if="acf.cta[0]"
                v-bind:href="acf.cta[0].cta.href"
                v-bind:target="acf.cta[0].cta.target"
                class="
                  btn
                  cta-pill
                  filled-red
                  icon
                  right-arrow
                  mr-3
                  mb-3 mb-xl-0
                "
                >{{ acf.cta[0].cta.text }}</a
              >
              <a
                v-if="acf.cta[1]"
                v-bind:href="acf.cta[1].cta.href"
                v-bind:target="acf.cta[1].cta.target"
                class="btn cta-pill hallow-red icon right-arrow"
                >{{ acf.cta[1].cta.text }}</a
              >
            </div>

            <div
              class="resources"
              v-if="acf['google-play'] || acf['apple-app-store']"
            >
              <a
                v-if="acf['apple-app-store']"
                target="_blank"
                v-bind:href="acf['apple-app-store']"
                class="btn apple-store d-block text-hide mb-2 mb-md-0"
                v-bind:class="{ 'mr-3': acf.layout['text-align'] !== 'center' }"
                >Download on the App Store</a
              >
              <a
                v-if="acf['google-play']"
                target="_blank"
                v-bind:href="acf['google-play']"
                class="btn google-play d-block text-hide"
                >Get it on Google Play</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-be3cb184", // info_30/70_icon-line_image_text_2cta
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-be3cb184 {
  padding: 5rem 0;
  background-position: center center;
  background-repeat: no-repeat;
}

.component {
  &.text-color-black {
    h2,
    h5 {
      color: $cc-resmed-black;

      &:before {
        background-color: $cc-resmed-black;
      }
    }
  }

  &.text-color-white {
    h2,
    h5 {
      color: $cc-resmed-white;

      &:before {
        background-color: $cc-resmed-white;
      }
    }

    h2 + div {
      color: $cc-resmed-white;
    }
  }

  h5 {
    position: relative;
    margin-bottom: 0.75rem;
  }

  h2 {
    position: relative;
    margin-bottom: 1.25rem;

    color: $cc-resmed-white;
  }

  .-has-eyebrow {
    h2,
    h5 {
      @extend %eyebrow-left;
    }

    .title + h2 {
      &:before {
        display: none;
      }
    }
  }

  figure {
    img {
      border-radius: 6px;

      &.-box-shadow {
        box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.125);
      }
    }

    @media (max-width: 575px) {
      margin: 0 auto;
    }

    @media (max-width: 767px) {
      img {
        margin: 0 auto;
      }
    }
  }

  .resources {
    @media (min-width: 768px) {
      display: flex;
      align-items: center;
    }
  }

  .call-to-action {
    + div {
      margin-top: 1rem;
    }
  }
}
</style>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-be3cb184 {
  .text-color-white li {
    border-bottom: 1px solid rgba($cc-resmed-white, 0.25);
  }

  .text-color-black li {
    border-bottom: 1px solid rgba($cc-resmed-dark-grey, 0.25);
  }

  ul {
    padding-left: 1.125rem;

    li {
      margin-bottom: 1.25rem;
      padding-bottom: 1.25rem;
    }
  }
}
</style>